module.exports = __webpack_public_path__ + "static/img/yichu.31b03c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yichu.png
// module id = BdBR
// module chunks = 24